import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import SalepointsList from './SalepointsList/SalepointsList';
import SalepointShow from './SalepointShow/SalepointShow';
import SalepointEdit from './SalepointEdit/SalepointEdit';
import SalepointCreate from './SalepointCreate/SalepointCreate';
import SalepointDelete from './SalepointDelete/SalepointDelete';

const Salepoints = ({ match }) => {
    return (
        <div className="Salepoints">
            <ContainerWrapper container="salepoints">
                <Route exact path={ match.path } component={SalepointsList} />
                <Route exact path={ `${ match.url }/new` } component={SalepointCreate} />
                <Route exact path={ `${ match.url }/show/:salepointId` } component={SalepointShow} />
                <Route exact path={ `${ match.url }/edit/:salepointId` } component={SalepointEdit} />
                <Route exact path={ `${ match.url }/delete/:salepointId` } component={SalepointDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Salepoints;
